module.exports = __webpack_public_path__ + "img/folder.12624c5a.png";